module.exports = __webpack_public_path__ + "static/media/dem_pub_exc_zon.b896e66b.png";